<template lang="pug">
  .PostContentHeader.post-content-header
    .post-content-header__left
    .post-content-header__right
      h1.post-content-header__title {{ data.name }}
      .post-content-header__publication-date.small-text.bold {{ data.publicationDateFull }}
</template>

<script>
import { BasePostClass } from 'Classes';

export default {
  name: 'PostContentHeader',
  props: {
    data: {
      type: BasePostClass,
      required: true,
    },
  },
};
</script>

<style lang="sass" scoped>
@import '~Styles/_variables'
.post-content-header
  width: 100%
  max-width: 1170px
  padding: 0 15px
  margin: 0 auto
  margin-bottom: 30px
  display: flex
  @media screen and (max-width: 767px)
    margin-bottom: 25px
  &__left
    width: 166px
    flex-shrink: 0
    margin-right: 30px
    @media screen and (max-width: 767px)
      display: none
  &__right
    width: 100%
    max-width: 750px
    @media screen and (max-width: 767px)
      max-width: 100%
  &__title
    color: $primary
    margin-bottom: 30px
    @media screen and (max-width: 767px)
      margin-bottom: 25px
</style>
